import React from 'react'
import { HomeFilterForm } from '../containers/HomeFiltersForm'
import StudiKWListing from '../containers/StudiKwListing'
import { FilterDataProvider } from '../HOC/studiKwFiltersContext'
import SetTitle from '../utils/set_title'
import Header from '../components/Headers/Header'

const Scheduling = () => {
  SetTitle('Scheduled Rank Inspector')

  return (
    <FilterDataProvider path="studiokw-scheduled/">
      <Header
        iconClass="ni ni-time-alarm text-white"
        title="Scheduled Rank Inspector"
        docLink="/docs/ranking_tools/scheduling/"
        headerClassName="main-page-title"
        headerChildren={<HomeFilterForm />}
      >
        <StudiKWListing page="scheduling" />
      </Header>
    </FilterDataProvider>
  )
}

export default Scheduling